var _ellipse, _rect, _ellipse2, _ellipse3, _rect2, _ellipse4, _ellipse5, _ellipse6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _ellipse7, _ellipse8, _rect3, _ellipse9, _ellipse10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlasticWrapRoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 44,
    viewBox: "0 0 154 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.441,
    cy: 21.315,
    rx: 18,
    ry: 4.55939,
    transform: "rotate(-90 149.441 21.315)",
    fill: "#CDA482"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 141.972,
    y: 38.923,
    width: 35.6081,
    height: 8.28749,
    transform: "rotate(-90 141.972 38.923)",
    fill: "#CDA482"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.559,
    cy: 21.315,
    rx: 18,
    ry: 4.55939,
    transform: "rotate(-90 141.559 21.315)",
    fill: "#E9CCB6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.827,
    cy: 21.3798,
    rx: 13.6636,
    ry: 2.07187,
    transform: "rotate(-90 140.827 21.3798)",
    fill: "url(#paint0_linear_10389_60269)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.707,
    y: 43.4733,
    width: 43.4733,
    height: 128.153,
    transform: "rotate(-90 13.707 43.4733)",
    fill: "#CCCCCC"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.3834,
    cy: 21.7366,
    rx: 21.7366,
    ry: 5.50153,
    transform: "rotate(-90 13.3834 21.7366)",
    fill: "#D9D9D9"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.537,
    cy: 21.7366,
    rx: 21.7366,
    ry: 5.50153,
    transform: "rotate(-90 141.537 21.7366)",
    fill: "#CCCCCC"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.3834,
    cy: 21.7366,
    rx: 8.97067,
    ry: 1.6181,
    transform: "rotate(-90 13.3834 21.7366)",
    fill: "#999999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2377 20.7016L22.1211 18.9764L25.0337 20.7016",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4892 20.7016L80.3726 18.9764L83.2852 20.7016",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7101 20.7016L28.5935 18.9764L31.5061 20.7016",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9616 20.7016L86.845 18.9764L89.7576 20.7016",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1824 20.7016L35.0659 18.9764L37.9785 20.7016",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.434 20.7016L93.3174 18.9764L96.23 20.7016",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6549 20.7016L41.5383 18.9764L44.4509 20.7016",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9064 20.7015L99.7898 18.9764L102.702 20.7015",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1272 20.7016L48.0107 18.9764L50.9233 20.7016",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.379 20.7015L106.262 18.9764L109.175 20.7015",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5996 20.7016L54.4831 18.9764L57.3956 20.7016",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.851 20.7015L112.735 18.9764L115.647 20.7015",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.072 20.7016L60.9555 18.9764L63.868 20.7016",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.324 20.7015L119.207 18.9764L122.12 20.7015",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5444 20.7016L67.4278 18.9764L70.3404 20.7016",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M121.796 20.7015L125.679 18.9764L128.592 20.7015",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M134.741 20.7015L138.624 18.9764L141.537 20.7015",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0168 20.7016L73.9002 18.9764L76.8128 20.7016",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M128.268 20.7015L132.152 18.9764L135.064 20.7015",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M141.213 20.7015L145.097 18.9764L146.715 20.184",
    stroke: "#D9D9D9",
    strokeWidth: 0.648649
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.04945,
    cy: 21.315,
    rx: 6.60317,
    ry: 1.19106,
    transform: "rotate(-90 6.04945 21.315)",
    fill: "#999999"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4406,
    cy: 21.315,
    rx: 18,
    ry: 4.55939,
    transform: "rotate(-90 12.4406 21.315)",
    fill: "#CDA482"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.97249,
    y: 38.923,
    width: 35.6081,
    height: 8.28749,
    transform: "rotate(-90 4.97249 38.923)",
    fill: "#CDA482"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.55939,
    cy: 21.315,
    rx: 18,
    ry: 4.55939,
    transform: "rotate(-90 4.55939 21.315)",
    fill: "#E9CCB6"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.82723,
    cy: 21.3798,
    rx: 13.6636,
    ry: 2.07187,
    transform: "rotate(-90 3.82723 21.3798)",
    fill: "url(#paint1_linear_10389_60269)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10389_60269",
    x1: 127.164,
    y1: 21.3798,
    x2: 154.491,
    y2: 21.3798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#846752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10389_60269",
    x1: -9.83633,
    y1: 21.3798,
    x2: 17.4908,
    y2: 21.3798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#846752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1712"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasticWrapRoll);
export default __webpack_public_path__ + "static/media/plastic_wrap_roll.96b2617f07c7a5d80cb9625331af0f21.svg";
export { ForwardRef as ReactComponent };